import { columnVisibilityFeature, createPaginatedRowModel, createSortedRowModel, rowPaginationFeature, rowSortingFeature, tableFeatures, } from '@tanstack/react-table';
export const appTableFeatures = tableFeatures({
    columnVisibilityFeature,
    rowSortingFeature,
    rowPaginationFeature,
    sortedRowModel: createSortedRowModel(),
    paginatedRowModel: createPaginatedRowModel(),
});
